module.exports = __webpack_public_path__ + "img/volume_down.b5dbe467.svg";